<template>
  <div class="footer w-full fixed left-0 bottom-0">
      <FooterButtons :bgcolour="bgcolour" />
  </div>
</template>

<script>
import FooterButtons from "@/components/content/buttons/FooterButtons.vue"

export default {
    components: {
        FooterButtons
    },
    data() {
        return {
            bgcolour: "bg-white"
        }
    }
}
</script>
